<template>
	<div style="overflow: hidden;"
		:style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px',  'marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">

    <el-carousel  loop style="overflow: hidden;"  :style="{'height':data.config.bannerHeight+'px',}" class="swiper">
      <el-carousel-item v-for="(item,index) in data.config.data" v-bind:key="'menuItem'+index">
        <div class="demo-carousel"><img @click="clickItem(item)" :src="item.image" style="width: 100%;height: 100%"/></div>
      </el-carousel-item>
    </el-carousel>
	</div>
</template>

<script>

	export default {
		name: 'Tpl_Banner',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
		},
		data() {
			return {
				indicatorDots: true,
				autoplay: true,
				interval: 4000,
				duration: 500
			}
		},
		methods: {
			clickItem(item){
        this.$router.push(item.path)
			},
			changeIndicatorDots(e) {
				this.indicatorDots = !this.indicatorDots
			},
			changeAutoplay(e) {
				this.autoplay = !this.autoplay
			},
			intervalChange(e) {
				this.interval = e.target.value
			},
			durationChange(e) {
				this.duration = e.target.value
			}
		}
	};
</script>

<style scoped>
	.uni-margin-wrap {
		width: 690rpx;
		width: 100%;
	}

	.swiper {
		height: 300rpx;
	}

	.swiper-item {
		display: block;
		height: 300rpx;
		line-height: 300rpx;
		text-align: center;
	}

	.swiper-list {
		margin-top: 40rpx;
		margin-bottom: 0;
	}

	.uni-common-mt {
		margin-top: 60rpx;
		position: relative;
	}

	.info {
		position: absolute;
		right: 20rpx;
	}

	.uni-padding-wrap {
		width: 550rpx;
		padding: 0 100rpx;
	}
</style>